import React from 'react';
import { useTranslation } from 'react-i18next';
import { Field } from 'redux-form';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import NativeSelect from '@mui/material/NativeSelect';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import { Stack } from '@mui/material';
import { __SetFilter } from '../../../../../actions/AsyncTable';
import store from './../../../../../store';
import { validateRequiredSelect } from '../validate';

const ROLE_STATUSES = [
    { id: '', title: 'news.selectRole' },
    { id: 3, title: 'news.franchisee' },
    { id: 4, title: 'news.teacher' },
];

const renderRoleField = ({ input, meta: { touched, error }, i18n, ...custom }) => {
    const showError = touched && error;
    return (
        <div
            style={{
                borderBottom: showError ? '2px solid red' : '2px solid transparent',
                paddingBottom: 4,
            }}
        >
            <NativeSelect {...input} {...custom}>
                {ROLE_STATUSES.map((item, key) => (
                    <option key={key} value={item.id}>
                        {i18n.t(item.title)}
                    </option>
                ))}
            </NativeSelect>
        </div>
    );
};

export default data => {
    const { i18n } = useTranslation();

    return (
        <Card>
            <CardContent>
                <div style={{ display: 'flex', marginBottom: 16 }}>
                    <Stack spacing={3} direction={'row'} alignItems={'center'}>
                        <Typography gutterBottom variant="h6" component="h2" style={{ marginBottom: 'unset' }}>
                            {i18n.t(data.label)}
                        </Typography>
                        <IconButton onClick={() => __SetFilter()(store.dispatch, store.getState)(data)}>
                            <DeleteIcon />
                        </IconButton>
                    </Stack>
                </div>
                <Field
                    name={data.code}
                    i18n={i18n}
                    component={renderRoleField}
                    type="text"
                    validate={validateRequiredSelect}
                />
            </CardContent>
        </Card>
    );
};
